import React from 'react';

const ResultScreen = ({ generatedImage, styleName, onRetake, onNext }) => {
  return (
    <div className="h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center px-3 sm:px-4 py-[0.5vh] sm:py-[1vh] overflow-hidden">
      {/* Title - Compact and responsive */}
      <div className="text-center flex-shrink-0 mb-[0.3vh] sm:mb-[0.5vh]">
        <h1 className="text-base sm:text-lg md:text-xl font-bold text-white">
          Your Transformation!
        </h1>
        <p className="text-[10px] sm:text-xs text-gray-300">
          <span className="font-semibold text-[#e5181e]">{styleName}</span>
        </p>
      </div>

      {/* Generated Image - Almost full screen with margin from buttons */}
      <div className="flex-1 flex items-center justify-center py-[0.3vh] sm:py-[0.5vh] w-full max-w-4xl min-h-0 mb-[2vh] sm:mb-[3vh]">
        <div className="relative w-full h-full max-h-full flex items-center justify-center">
          <img
            src={generatedImage}
            alt="AI generated result"
            className="max-w-full max-h-full rounded-xl sm:rounded-2xl shadow-2xl border-2 sm:border-3 md:border-4 border-[#e5181e]/50 animate-fade-in object-contain"
          />

          {/* Decorative corners - responsive sizing */}
          <div className="absolute -top-1 -left-1 sm:-top-2 sm:-left-2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 border-t-2 border-l-2 sm:border-t-3 sm:border-l-3 md:border-t-4 md:border-l-4 border-[#e5181e] rounded-tl-lg sm:rounded-tl-xl"></div>
          <div className="absolute -top-1 -right-1 sm:-top-2 sm:-right-2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 border-t-2 border-r-2 sm:border-t-3 sm:border-r-3 md:border-t-4 md:border-r-4 border-[#e5181e] rounded-tr-lg sm:rounded-tr-xl"></div>
          <div className="absolute -bottom-1 -left-1 sm:-bottom-2 sm:-left-2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 border-b-2 border-l-2 sm:border-b-3 sm:border-l-3 md:border-b-4 md:border-l-4 border-[#e5181e] rounded-bl-lg sm:rounded-bl-xl"></div>
          <div className="absolute -bottom-1 -right-1 sm:-bottom-2 sm:-right-2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 border-b-2 border-r-2 sm:border-b-3 sm:border-r-3 md:border-b-4 md:border-r-4 border-[#e5181e] rounded-br-lg sm:rounded-br-xl"></div>
        </div>
      </div>

      {/* Action Buttons - Compact bottom section */}
      <div className="w-full max-w-4xl flex-shrink-0 pb-[0.5vh] sm:pb-[1vh]">
        <div className="flex gap-1.5 sm:gap-2 md:gap-3 px-1 sm:px-2">
          <button
            onClick={onRetake}
            className="flex-1 px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-full font-bold text-xs sm:text-sm md:text-base hover:from-gray-500 hover:to-gray-600 transition-all transform hover:scale-105 active:scale-95 shadow-xl"
          >
            🔄 Retake
          </button>

          <button
            onClick={onNext}
            className="flex-1 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 bg-[#e5181e] text-white rounded-full font-bold text-xs sm:text-sm md:text-base hover:bg-[#c01419] transition-all transform hover:scale-105 active:scale-95 shadow-2xl"
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultScreen;
